import { XMarkIcon } from "@heroicons/react/24/outline";
import { Button } from "./catalyst/button";
import { useEffect } from "react";

export const PdfPreviewer: React.FC<any> = ({ doc, closeClicked }) => {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") closeClicked();
    };
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative w-11/12 h-5/6 bg-white dark:bg-gray-800 rounded-lg overflow-hidden">
        <div className="absolute top-4 right-4 z-10">
          <>
            <Button
              className="p-2 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-full"
              onClick={closeClicked}
            >
              <XMarkIcon className="w-6 h-6" />
            </Button>
          </>
        </div>
        <object data={`/api/static/images/${doc.documentUrl}`} type="application/pdf" className="w-full h-full">
          <embed src={`/api/static/images/${doc.documentUrl}`} type="application/pdf" />
        </object>
      </div>
    </div>
  );
};
